import { Skeleton } from '@/_components/ui/skeleton'

export function ApplicationKanbanCardSkeleton() {
  return (
    <div className="flex flex-col divide-y divide-brand-grayscale-3">
      <div className="flex flex-col gap-y-1.5 p-4">
        <Skeleton className="h-5 w-32 rounded-sm" />
        <Skeleton className="h-4 w-24 rounded-sm" />
        <Skeleton className="h-4 w-20 rounded-sm" />
        <Skeleton className="h-5 w-28 rounded-sm" />
      </div>
      <div className="flex flex-row items-center justify-between px-4 py-3">
        <Skeleton className="h-4 w-16 rounded-sm" />
        <Skeleton className="h-4 w-14 rounded-sm" />
      </div>
    </div>
  )
}
